module.exports = "/images/vs.png?b6d1adca6708c820db437aeb0fa5cc32";


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/img/vs.png
// module id = CGIz
// module chunks = 70